__turbopack_context__.v({
  "root": "styles-module__Zjc0ua__root",
});
